import { PatientTreatmentListResponseDto } from "@/data/dto/patient-treatement-detail-list/patient-treatment-list-reponse-dto";
import { AddTreatmentRequestPayload } from "@/data/payload/treatment/add-treatment-request-payload";
import { FetchPatientTreatmentListRequestPayload } from "@/data/payload/treatment/fetch-patient-treatement-list-request-payload";
import { FetchTreatmentDetailRequestPayload } from "@/data/payload/treatment/fetch-treatment-detail-request-payload";
import { TerminateTreatmentRequestPayload } from "@/data/payload/treatment/pause-treatment-request-payload";
import { ModifyTreatmentMemoRequestPayload } from "@/data/payload/treatment/treatment-memo-mofity-request-payload";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { TreatmentDetailResponseDto } from "../dto/patient-treatement-detail-list/treatment-detail-reponse-dto";
import { AddTreatmentResponseDto } from "../dto/treatment-source/add-treatment-response-dto";
import { FetchActivityChartDataRequestPayload } from "../payload/treatment/fetch-activity-chart-data-request-payload";
import { ActivityByProgressDayResponseDto } from "../dto/patient-treatement-detail-list/activity-by-pregress-day-response-dto";

export class TreatmentSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async addTreatment(
    payload: AddTreatmentRequestPayload
  ): Promise<SATResult<AddTreatmentResponseDto, SATError>> {
    return this.postTreatment(URLList.TREATMENT.ADD_TREATMENT, payload, "addTreatment");
  }

  /** v2 — 스토어 이용권을 소진하며 등록 (서버가 미사용 이용권을 요구) */
  async addTreatmentWithVoucher(
    payload: AddTreatmentRequestPayload
  ): Promise<SATResult<AddTreatmentResponseDto, SATError>> {
    return this.postTreatment(URLList.TREATMENT.ADD_TREATMENT_V2, payload, "addTreatmentWithVoucher");
  }

  private async postTreatment(
    url: string,
    payload: AddTreatmentRequestPayload,
    label: string
  ): Promise<SATResult<AddTreatmentResponseDto, SATError>> {
    try {
      console.log("[TreatmentSource] ::", label, ":: payload", payload);
      const response = await this.client.post(url, payload);
      console.log("[TreatmentSource] ::", label, "성공 |", payload);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] ::", label, "|", satError);
      return SATResult.failure(satError);
    }
  }

  async modifyTreatmentMemo(
    payload: ModifyTreatmentMemoRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      console.log("[TreatmentSource] :: modifyTreatmentMemo :: payload", payload);
      const url = `${URLList.TREATMENT.ADD_TREATMENT_MEMO}/${payload.treatmentInfoUuid}`;
      await this.client.put(url, payload.payload);
      console.log("[TreatmentSource] :: modifyTreatmentMemo 성공 | ", payload);
      return SATResult.success(void 0);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] :: modifyTreatmentMemo | ", satError);
      return SATResult.failure(satError);
    }
  }

  async fetchPatientTreatmentList(
    payload: FetchPatientTreatmentListRequestPayload
  ): Promise<SATResult<PatientTreatmentListResponseDto, SATError>> {
    try {
      const url = `${URLList.TREATMENT.GET_TREATMENT_LIST}/${payload.patientUuid}`;
      const response = await this.client.get(url);
      console.log("[TreatmentSource] :: fetchPatientTreatmentList 성공 | ", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] :: fetchPatientTreatmentList | ", satError);
      return SATResult.failure(satError);
    }
  }

  async fetchTreatmentDetail(
    payload: FetchTreatmentDetailRequestPayload
  ): Promise<SATResult<TreatmentDetailResponseDto, SATError>> {
    try {
      const url = `${URLList.TREATMENT.GET_TREATMENT_DETAIL}/${payload.patientUuid}/${payload.treatmentInfoUuid}`;

      // console.log("[TreatmentSource] :: fetchTreatmentDetail :: url", url);
      // // INSERT_YOUR_CODE
      // // TreatmentDetailResponseDto의 mock 데이터를 생성하여 반환합니다.
      // const mockData = {
      //   treatmentInfo: {
      //     treatmentInfoUuid: "mock-uuid-1234",
      //     step: 1,
      //     state: "inProgress",
      //     startDate: "2024-06-01T00:00:00.000Z",
      //     endDate: "2024-07-01T00:00:00.000Z",
      //     actuallyExecutedDay: 2,
      //     recommendedExecutedDay: 5,
      //     actuallyPlayTime: 120,
      //     recommendedTotalPlayTime: 300,
      //     doctorName: "홍길동",
      //     memo: "모의 치료 메모입니다.",
      //   },
      //   activitiesByProgressDay: {
      //     1: {
      //       uuid: "mock-uuid-1",
      //       dateOfDay: "2024-06-10",
      //       totalPlayTime: 60,
      //       lightEstimationCount: 2,
      //       startTime: "2024-07-01T08:00:00.000Z",
      //       endTime: "2024-07-01T08:10:00.000Z",
      //       state: 2,
      //     },
      //     41: {
      //       uuid: "mock-uuid-2",
      //       dateOfDay: "2024-07-20",
      //       totalPlayTime: 60,
      //       lightEstimationCount: 3,
      //       startTime: "2024-07-02T09:00:00.000Z",
      //       endTime: "2024-07-02T09:10:00.000Z",
      //       state: 1,
      //     },
      //   },
      // };
      // return SATResult.success(JSON.parse(JSON.stringify(mockData)));

      const response = await this.client.get(url);
      console.log("[TreatmentSource] :: fetchTreatmentDetail 성공 | ", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] :: fetchTreatmentDetail | ", satError);
      return SATResult.failure(satError);
    }
  }

  async fetchAcitivyChartData(
    payload: FetchActivityChartDataRequestPayload
  ): Promise<SATResult<ActivityByProgressDayResponseDto, SATError>> {
    try {
      const url = `${URLList.TREATMENT.FETCH_ACTIVITY_CHART_DATE_BY_GZIP}/${payload.patientUuid}/${payload.treatmentInfoUuid}/${payload.planUuid}`;
      const response = await this.client.get(url);

      console.log("[TreatmentSource] :: fetchAcitivyChartDate 성공 | ", payload);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] :: fetchAcitivyChartDate | ", satError);
      return SATResult.failure(satError);
    }
  }

  async terminateTreatment(
    payload: TerminateTreatmentRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.TREATMENT.TERMINATE_TREATMENT}/${payload.treatmentInfoUuid}`;
      await this.client.put(url);
      console.log("[TreatmentSource] :: terminateTreatment 성공 | ", payload);
      return SATResult.success(void 0);
    } catch (error: unknown) {
      const satError = errorConverter.convertError(error);
      console.log("[TreatmentSource] :: terminateTreatment | ", satError);
      return SATResult.failure(satError);
    }
  }
}
